import { ConfigurationTypes } from "../../vendor_core/core/src/const/ConfigurationTypes";
import ISettingsConfig from "../../vendor_core/core/src/managers/contracts/configurations/ISettingsConfig";
import IRulesScenes from "../../vendor_core/core/src/managers/contracts/configurations/settings/IRulesScenes";
import ISettingsRulesData from "../../vendor_core/core/src/managers/contracts/configurations/settings/ISettingsRulesData";

class SettingsConfig implements ISettingsConfig {
    type: ConfigurationTypes = ConfigurationTypes.SETTINGS;
    rulesScenes: IRulesScenes = {
        paytable: "paytable",
        featureRules: "featurerules",
        gameRules: "gamerules"
    };
    biggestTextScene: string = "gamerules~1";
    biggestTextTextField: string = "game_rule_1_text_1";
    scenesForCalculatingMinFontSize: string[] = [
        "gamerules~1",
        "featurerules~1",
        "featurerules~2",
        "featurerules~3",
        "featurerules~4",
        "featurerules~5",
        "featurerules~6"
    ];
    /**
     * @param name First part of the key for rules defined in localization (without the number of the end of the key)
     * @param rules This represents the rules which will be seen on one rules page in settings
     * - "from" (`rules[0]`) number of define in localization rules
     * - "to" (`rules[1]`) number of define in localization rules
     * @param sceneTextField This is the name of the body text field in PSD who is collecting all visible rules on one setting page
     */
    rulesData: ISettingsRulesData[] = [
        {
            name: "rules_pg_5_",
            rulesDimensions: [1, 1],
            sceneTextField: "rules_pg_5"
        }
    ];
    applyMinFontSizeTextFields: string[] = [
        // "ui_sounds",
        // "ui_music",
        // "ui_turbo",
    ];

    forceCalculateBoundFields?: string[] = [
        "ui_game_rules",
        "paytable_wild",
        "pt_free_spins"
    ];
    forceCalculateBoundScenes?: string[] = [
        "paytable~1",
        "paytable~2",
        "paytable~3",
        "paytable~4",
        "paytable~5",
        "paytable~6",
        "paytable~7",
        "paytable~8",
        "gamerules~1"
    ];
    ptMap: { key: string; multiplier: number }[] = [];
    pageRestrictions: { pageName: string; hasRestriction: () => boolean }[] = [
        // {
        //     pageName: "gamerules~4",
        //     hasRestriction: () => {
        //         return (
        //             !App.config.hasJackpotsFeature ||
        //             !JackpotsModel.jackpotsAvailable
        //         );
        //     }
        // }
    ];
}

export default new SettingsConfig();
